export const MOM_BOOTSTRAP_VERSION = 1

let userInfo = null
let routers = null

function cloneJsonValue (value) {
  return JSON.parse(JSON.stringify(value))
}

export function setMomBootstrapUserInfo (value) {
  userInfo = value && typeof value === 'object' ? cloneJsonValue(value) : null
}

export function setMomBootstrapRouters (value) {
  routers = Array.isArray(value) ? cloneJsonValue(value) : null
}

export function getMomBootstrap () {
  if (!userInfo || !routers) return null
  return {
    version: MOM_BOOTSTRAP_VERSION,
    userInfo,
    routers
  }
}

export function clearMomBootstrap () {
  userInfo = null
  routers = null
}
